import { api } from '@/api/api'
import { pathAuth } from '@/configurações/rotasApi'
import { useQuery } from '@tanstack/react-query'

export const useListPeriod = () => {
  const { data } = useQuery({
    queryKey: ['periodo'],
    queryFn: async () => await endPoint(),
  })

  return { data }
}

async function endPoint(): Promise<listPeriodo[]> {
  const result = await api().get(`/${pathAuth}/instituicaoPeriodo/listar`)
  return result.data.data
}

type listPeriodo = {
  id: string
  nome: string
  instituicaoId: string
}
